import { makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

// @ts-expect-error
const useStyles = makeStyles((theme: Theme) => {
  return {
    value: {
      fontSize: '1.5rem',
      fontWeight: theme.typography.fontWeightMedium,
    },
  };
});

export const Value = (props: { value?: string }) => {
  const classes = useStyles();
  return (
    <Typography component="span" className={classes.value}>
      {props.value}
    </Typography>
  );
};
